import React, { useState } from 'react'
import type { GetServerSideProps } from 'next'
import { createServerSideHelpers } from '@trpc/react-query/server'

import { appRouter } from '@aqua/api'

import Filters from '~/components/search/Filters'
import ImpactedAreas from '~/components/search/ImpactedAreas'
import { getServerSideHelper } from '~/utils/server-side-herpers'
import Layout from './layout'

const Search = ({ searchCount }: { searchCount: number }) => {
  const [showFilters, setShowFilters] = useState<boolean>(false)

  return (
    <Layout searchCount={searchCount}>
      <main className='min-h-[calc(100vh-90px)] w-full bg-[#e2e8f0] pb-20 pt-36'>
        {!showFilters ? (
          <ImpactedAreas
            onPressNext={() => {
              setShowFilters(true)
            }}
          />
        ) : (
          <Filters
            onPressBack={() => {
              setShowFilters(false)
            }}
          />
        )}
      </main>
    </Layout>
  )
}

export default Search

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { query } = context
  const selectedImpactAreas = query.impact_areas as string | undefined
  const selectedCategories = query.categories as string | undefined
  const selectedTimeFrame = query.time_frame as string | undefined
  const helpers = await getServerSideHelper(context)
  const count = await helpers.stories.searchCount.fetch({
    impact_areas: selectedImpactAreas ?? null,
    categories: selectedCategories,
    time_frame: selectedTimeFrame,
  })

  return {
    props: {
      searchCount: count?.[0]?.value ?? 0,
    },
  }
}
